module.exports = "http://cdn.realive.com.ua/src/views/donate/main/elements/shop/img/p_2.svg";